/**
 * Component that should wrap a Post node in order to capture the events happening on the post.
 */
(function () {
    angular.module('tradersyard').component('tyPromotedPost', {
        // language=HTML
        template: '<div ng-transclude in-view="$ctrl.handleInView($inview)"></div>',
        transclude: true,
        bindings: {
            isPromoted: '<',
            postId: '<',
            boostId: '<',
            nodePost: '=',
        },
        controller: PromotedPostController,
    });

    PromotedPostController.$inject = ['AdsService', '$element', '$timeout', '$window', '$scope'];

    /**
     *
     * @param AdsService
     * @param {angular.IRootElementService} $element
     * @param $timeout
     * @param $window
     * @param $scope
     * @constructor
     */
    function PromotedPostController(AdsService, $element, $timeout, $window, $scope) {
        var ctrl = this;

        ctrl.postId = undefined;
        ctrl.boostId = undefined;

        ctrl.inView = false;
        ctrl.$onInit = $onInit;

        ctrl.handleInView = function (inView) {};

        /**
         * @param {ng.IOnChangesObject} changes
         */
        function $onInit(changes) {
            if (!ctrl.isPromoted) {
                return;
            }

            if (!ctrl.postId || !ctrl.boostId) {
                console.warn('postId and boostId not passed for boosted post');
                return;
            }

            console.log(
                '[BOOSTED POSTS] Hooking into events for boosted post. Post: %d, Boost: %d',
                ctrl.postId,
                ctrl.boostId
            );

            hookIntoPromotedPostEvents();
        }

        function hookIntoPromotedPostEvents() {
            // attach click listener specifically on anchor tags, because sometimes we have nested dom elements,
            // e.g. a > h2, which would trigger click with target of h2 while bubbling and opening the link,
            // and this is something we want to capture
            $element.on('click', 'a', handleAnchorClicks);

            // TODO handle middle mouse button clicks
            // $element.on('auxclick', 'a', function (e) {});

            $scope.$on('preview-touch', function (event, args) {
                // TODO: Maybe just use boosts:engagement event? We could only process when expanding then?
                // We should count clicking/viewing images as engagements. This works with any content than can be opened for preview.
                // IMPORTANT: The "preview-touch" event is a very generic event, which can be emitted for all "preview" actions from any place.
                //  We need to filter the events to see if we got it from the right place, which is from a child element contained inside promoted post.
                const { target } = args;

                // check if we can find the target element inside the promoted post parent element
                if (!isElementChildOf(target, $element)) {
                    return; // not a child of the component
                }

                AdsService.metricsHitEngagements(ctrl.postId, ctrl.boostId);
            });

            $scope.$on('boosts:engagement', (event, args) => {
                const { target } = args;

                if (!isElementChildOf(target, $element)) {
                    return; // not a child of the component
                }

                AdsService.metricsHitEngagements(ctrl.postId, ctrl.boostId);
            });

            $element.on('click', '[read-more-expand]', function () {
                // Button you can click to expand the content of a Post. We count it as an engagement.
                AdsService.metricsHitEngagements(ctrl.postId, ctrl.boostId);
            });

            $element.on('click', '[data-boosts-triggers="engagement"]', function () {
                // Sometimes we need to count clicks on some empty anchor tag as engagements.
                // Using a custom attr we can easily mark some elements as triggers
                AdsService.metricsHitEngagements(ctrl.postId, ctrl.boostId);
            });

            $element.on('click', '[like-form]', function () {
                AdsService.metricsHitEngagements(ctrl.postId, ctrl.boostId);
            });

            $element.on('click', 'ty-translate-entry button', function () {
                AdsService.metricsHitEngagements(ctrl.postId, ctrl.boostId);
            });

            $window.addEventListener('blur', function () {
                // FIXME: this is not very reliable, but the alternative is to implement all possible video providers?
                // Hacky and flaky way to detect clicks on iFrames.
                //
                // Detects first click on iFrame when changing focus from the main window to the iFrame window.
                // Timeout might help with FireFox support.
                //
                // It can be used with YouTube, Vimeo and other iFrames, which are a possible Post attachments.
                $timeout(function () {
                    const target = document.activeElement;

                    if (!(target instanceof HTMLIFrameElement)) {
                        return; // not an iframe click
                    }

                    if (!isElementChildOf(target, $element)) {
                        return; // not a child of the component
                    }

                    console.log('[BOOSTED POSTS] iFrame click detected');

                    AdsService.metricsHitEngagements(ctrl.postId, ctrl.boostId);
                }, 0);
            });

            ctrl.handleInView = handleInView;
        }

        function handleAnchorClicks(event) {
            console.log('[BOOSTED POSTS] Link clicked...', event);

            // we need to check `event.currentTarget` instead of `event.target`,
            // because something like this `<a><h2>Text</h2></a>` would give as <h2> as target.
            const target = event.currentTarget;

            // check if we have any hostname - maybe there is a blank href tag.
            // NOTE: hostname is always there, even if href attr is something like "/some-root-relative-url/to-some-page"
            if (!target.hostname) {
                console.log('..., but ignoring because of empty hostname.');
                return; // blank href attr probably
            }

            // outgoing links are counted as clicks, links inside TY are counted as engagements
            const isOutLink = 'A' === target.tagName && $window.location.hostname !== target.hostname;

            if (isOutLink) {
                AdsService.metricsHitClick(ctrl.postId, ctrl.boostId, target.href);
            } else {
                // this must be an onsite-link - this is just an engagement for us
                AdsService.metricsHitEngagements(ctrl.postId, ctrl.boostId);
            }
        }

        /**
         * Handles events that should happen when the Boosted Post enters the viewport.
         * This includes counting impressions and views.
         *
         * Impressions happen as soon as the Boost enters the Viewport.
         * View will happen if after 3 seconds the user still has the Boost in the Viewport.
         *
         * @param inView
         */
        function handleInView(inView) {
            console.log('[BOOSTED POSTS] In viewport: %s / Post: %s / Boost: %s', inView, ctrl.postId, ctrl.boostId);

            ctrl.inView = inView;

            if (!inView) return; // not in view, so we have nothing to do here.

            AdsService.metricsHitImpressions(ctrl.postId, ctrl.boostId);

            $timeout(function () {
                console.log('Still in viewport: %s / Post: %s / Boost: %s', ctrl.inView, ctrl.postId, ctrl.boostId);

                if (ctrl.inView) {
                    // still in view after 3 seconds
                    AdsService.metricsHitViews(ctrl.postId, ctrl.boostId);
                }
            }, 3000);
        }
    }

    function isElementChildOf(child, parent) {
        return !!parent.find(child).get(0);
    }
})();
